import { ReactComponent as Bankdetails } from '../../../Assets/Images/bankDetails.svg';
import { ReactComponent as Delete } from '../../../Assets/Images/delete-icon.svg';
import { encode, decode } from 'base-64';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import { regex } from '../../../utils/constants';
import {
  deleteBankUpi,
  getUserDetail,
  saveBankData,
  getIfscDetails,
  saveBankTransaction,
  bankVerify
} from '../../../Services/action';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AppTracking from '../../../Components/appTracking';
import { DataContext } from '../../../Components/DataContext.js';


const BankDetailsPage = () => {
  const navigate = useNavigate();
  const { data, setData } = useContext(DataContext);
  const newData = { ...data };
  const mobileNum = newData.mobileNumber;
  const [userDetails, setUserDetails] = useState([]);
  const [accountNumber, setAccountNumber] = useState('');
  const [reAccountNumber, setReAccountNumber] = useState('');
  const [benName, setBenName] = useState('');
  const [ifsc, setIfsc] = useState('');
  const [resultAccount, setResultAccount] = useState(false);
  const [resultAccounts, setResultAccounts] = useState(false);
  const [resultIfsc, setResultIfsc] = useState(false);
  const [resultName, setResultName] = useState(false);
  const [accountError, setAccountError] = useState('');
  const [accountErrors, setAccountErrors] = useState('');
  const [ifscError, setIfscError] = useState('');
  const [benNameError, setBenNameError] = useState('');

  const [userInfo, setUserDetailsBankMsg] = useState('');

  const [bankName, setBankName] = useState('');
  const [branchName, setBranchName] = useState('');
  const [verifyErrorMsg, setVerifyErrorMsg] = useState('');


  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalWarning, setIsModalWarning] = useState(false);
  const [isModalWarningYesNo, setIsModalWarningYesNo] = useState(false);


  const [modal, setModal] = useState('');
  const [loader, setLoader] = useState(false);
  const [loaderTrans, setLoaderTrans] = useState(false);
  const [accountIsMax, setAccountIsMax] = useState('');


  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    return 'unknown';
  };

  const saveTrans = (bankMappingId, scanVal) => {
    setLoaderTrans(true);

    navigator.permissions.query({ name: 'geolocation' }).then((result) => {

      if (result.state === 'granted') {
        // Permission was granted
        navigator.geolocation.getCurrentPosition(function (position) {
          let latitude = position.coords.latitude;
          let longitude = position.coords.longitude;
          if (latitude != null && longitude != null) {
            saveBankTransaction({
              "mobileNo": mobileNum,
              "userBankMappingId": bankMappingId,
              "userUpiMappingId": "",
              "couponCode": newData.couponCode,
              "couponVal": scanVal,
              "transactionState": "start",
              "transId": "",
              "creditorName": benName.toUpperCase(),
              "creditorCreditorAgentFinancialInstitutionBranchCode": "",
              "creditorCreditorAgentFinancialInstitutionName": benName,
              "creditorCreditorAgentFinancialInstitutionBIC": encode(ifsc),
              "creditorCreditorAgentCreditorAccountId": encode(accountNumber),
              "reditorCreditorAgentCreditorIdentifierType": "IBFT",

              "latitude": String(latitude),
              "longitude": String(longitude),
              "state": "",
              "city": "",
              "pincode": 0
            }, newData.token)
              .then((data) => {
                if (data.statusMsg.code === 0) {
                  setLoaderTrans(false);
                  setAccountNumber('');
                  setReAccountNumber('');
                  setIfsc('');
                  setBenName('');
                  setBankName('');
                  setBranchName('');
                  newData.transactionStatus = true;
                  setData(newData);
                  navigate('/amountCredited');
                }
                else if (data.statusMsg.code === 1) {
                  setModal(data.statusMsg.msg);
                  setIsModalWarning(true);
                  setLoaderTrans(false);
                }
                else if (data.statusMsg.code === -1) {
                  setModal(data.statusMsg.msg);
                  setIsModalError(true);
                  setLoaderTrans(false);
                }
              })
              .catch((error) => {
                setLoaderTrans(false);
              });
          }
          else {
            setLoaderTrans(false);
            if (getMobileOperatingSystem() == 'Android') {
              setModal("We couldn't find your location.Please allow from settings to proceed further.");
            }
            else {
              setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
            }
            setIsModalWarning(true);
          }
        })
      }
      else if (result.state === 'denied') {
        setLoaderTrans(false);

        if (getMobileOperatingSystem() == 'Android') {
          setModal("We couldn't find your location.Please allow from settings to proceed further.");
        }
        else {
          setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
        }
        setIsModalWarning(true);
      }
      else if (result.state === 'prompt') {
        navigator.geolocation.getCurrentPosition(
          (position) => {

            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;
            if (latitude != null && longitude != null) {
              saveBankTransaction({
                "mobileNo": mobileNum,
                "userBankMappingId": bankMappingId,
                "userUpiMappingId": "",
                "couponCode": newData.couponCode,
                "couponVal": scanVal,
                "transactionState": "start",
                "transId": "",
                "creditorName": benName.toUpperCase(),
                "creditorCreditorAgentFinancialInstitutionBranchCode": "",
                "creditorCreditorAgentFinancialInstitutionName": benName,
                "creditorCreditorAgentFinancialInstitutionBIC": encode(ifsc),
                "creditorCreditorAgentCreditorAccountId": encode(accountNumber),
                "reditorCreditorAgentCreditorIdentifierType": "IBFT",

                "latitude": String(latitude),
                "longitude": String(longitude),
                "state": "",
                "city": "",
                "pincode": 0
              }, newData.token)
                .then((data) => {
                  if (data.statusMsg.code === 0) {
                    setLoaderTrans(false);
                    setAccountNumber('');
                    setReAccountNumber('');
                    setIfsc('');
                    setBenName('');
                    setBankName('');
                    setBranchName('');
                    newData.transactionStatus = true;
                    setData(newData);
                    navigate('/amountCredited');
                  }
                  else if (data.statusMsg.code === 1) {
                    setModal(data.statusMsg.msg);
                    setIsModalWarning(true);
                    setLoaderTrans(false);
                  }
                  else if (data.statusMsg.code === -1) {
                    setModal(data.statusMsg.msg);
                    setIsModalError(true);
                    setLoaderTrans(false);
                  }
                })
                .catch((error) => {
                  setLoaderTrans(false);
                });
            }
            else {
              setLoaderTrans(false);

              if (getMobileOperatingSystem() == 'Android') {
                setModal("We couldn't find your location.Please allow from settings to proceed further.");
              }
              else {
                setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
              }
              setIsModalWarning(true);
            }
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED) {
              setLoaderTrans(false);

              if (getMobileOperatingSystem() == 'Android') {
                setModal("We couldn't find your location.Please allow from settings to proceed further.");
              }
              else {
                setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
              }
              setIsModalWarning(true);
              // Handle permission denied
            } else {
              setLoaderTrans(false);
              if (getMobileOperatingSystem() == 'Android') {
                setModal("We couldn't find your location.Please allow from settings to proceed further.");
              }
              else {
                setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
              }

              setIsModalWarning(true);
              // Handle other errors
            }
          })
      }
    });
  }


  const handleSubmit = () => {
    setLoaderTrans(true);
    saveBankData({
      mobileNo: mobileNum,
      name: benName.toUpperCase().trimEnd(),
      ifsc: encode(ifsc.toLocaleUpperCase()),
      paymentMode: 'bank',
      bankName: bankName,
      branchName: branchName,
      accountNo: encode(accountNumber.toLocaleUpperCase()),
      upiId: ''

    }, newData.token)
      .then((data) => {
        let bankUpiId = data.data.bankUpiId;

        if (data.statusMsg.code === 0) {
          if (userDetails == "") {

            bankVerify({
              "mobileNo": mobileNum,
              "userBankMappingId": bankUpiId,
              "userUpiMappingId": "",
              "couponCode": newData.couponCode,
              "couponVal": newData.scanVal,
              "transactionState": "start",
              "transId": "",
              "creditorName": benName.toUpperCase(),
              "creditorCreditorAgentFinancialInstitutionBranchCode": "",
              "creditorCreditorAgentFinancialInstitutionName": benName,
              "creditorCreditorAgentFinancialInstitutionBIC": encode(ifsc),
              "creditorCreditorAgentCreditorAccountId": encode(accountNumber),
              "reditorCreditorAgentCreditorIdentifierType": "IBFT",
            }, newData.token)
              .then((data) => {
                setLoaderTrans(false);
                if (data.statusMsg.code === 0) {
                  setVerifyErrorMsg('');
                  saveTrans(bankUpiId, newData.scanVal);
                }
                else if (data.statusMsg.code === 1) {
                  setVerifyErrorMsg(data.statusMsg.msg);
                  setModal(data.statusMsg.msg);
                  setIsModalWarning(true);
                  setLoaderTrans(false);
                  setReAccountNumber('');
                  setIfsc('');
                  setBenName('');
                  setBankName('');
                  setBranchName('');


                }
                else if (data.statusMsg.code === -1) {
                  setModal(data.statusMsg.msg);
                  setIsModalError(true);
                  setLoaderTrans(false);
                  setReAccountNumber('');
                  setIfsc('');
                  setBenName('');
                  setBankName('');
                  setBranchName('');


                }
              }).catch((error) => {
                setLoaderTrans(false);
              });
          }
          else {
            saveTrans(bankUpiId, newData.scanVal);
          }

        }
        else if (data.statusMsg.code === 1) {
          setModal(data.statusMsg.msg);
          setIsModalWarning(true);
          setAccountNumber('');
          setReAccountNumber('');
          setIfsc('');
          setBenName('');
          setBankName('');
          setBranchName('');
          setLoaderTrans(false);
        }
        else if (data.statusMsg.code === -1) {
          setModal(data.statusMsg.msg);
          setIsModalError(true);
          setAccountNumber('');
          setReAccountNumber('');
          setIfsc('');
          setBenName('');
          setBankName('');
          setBranchName('');
          setLoaderTrans(false);

        }
      })
      .catch((error) => {
        setLoaderTrans(false);

      });

  }
  const maskBankAccountNumber = (accountNumber) => {
    // Check if accountNumber is a string and has more than 4 characters
    if (typeof accountNumber === 'string' && accountNumber.length > 4) {
      const visibleChars = accountNumber.slice(-4); // Last 4 characters visible
      const maskedChars = '*'.repeat(accountNumber.length - 4); // Mask all characters except last 4
      return maskedChars + visibleChars; // Concatenate masked and visible characters
    } else {
      return accountNumber; // Return original value if it doesn't meet the conditions
    }
  };

  const getUserInfo = () => {
    setLoader(true);
    getUserDetail(mobileNum, newData.couponCode, newData.token)
      .then((data) => {
        setUserDetailsBankMsg(data.data.bnkAccntMsg);
        setAccountIsMax(data.data.maxAcReached);

        if (data.data.bankDetails) {
          const bankDetailed = JSON.parse(data.data.bankDetails);

          setUserDetails(bankDetailed);
          try {
            setAccountNumber(decode(bankDetailed[0].BANK_ACCOUNT_NO));
            setReAccountNumber(decode(bankDetailed[0].BANK_ACCOUNT_NO));
            setIfsc(decode(bankDetailed[0].IFSC_CODE));
          }
          catch (error) {
            setAccountNumber('');
            setReAccountNumber('');
            setIfsc('');
          }
          setBenName(bankDetailed[0].BENEFICIARY_NAME);
          setBankName(bankDetailed[0].BANK_NAME);
          setBranchName(bankDetailed[0].BRANCH_NAME);
          let pattern = regex.accountRegex;
          let resAccount = pattern.test(decode(bankDetailed[0].BANK_ACCOUNT_NO));
          setResultAccount(resAccount);
          setResultAccounts(resAccount);
          let patterns = regex.ifscRegex;
          let resIfsc = patterns.test(decode(bankDetailed[0].IFSC_CODE));
          setResultIfsc(resIfsc);
          let patternss = regex.nameRegex;
          let resName = patternss.test(bankDetailed[0].BENEFICIARY_NAME);
          setResultName(resName);
          setLoader(false);
        }
        else {
          setResultAccount(false);
          setResultAccounts(false);
          setResultIfsc(false);
          setResultName(false);
          setLoader(false);

        }
      })
      .catch((error) => {
        setLoader(false);

      });
  };
  useEffect(() => {
    if (newData.token === null) {
      navigate('/')
    }
    getUserInfo();

  }, []);
  const handleClose = (type) => {
    if (type === 1) {
      setIsModalSuccess(false);
    }
    else if (type === 2) {
      setIsModalError(false);
    }
    else if (type === 3) {
      setIsModalWarning(false);
    }
    else if (type === 4) {
      setIsModalWarningYesNo(false);
    }
    getUserInfo();
  }
  const handlePaste = (event) => {
    // Prevent pasting into input2
    event.preventDefault();
  }

  const deleteAccount = () => {
    if (accountIsMax == 'Y') {
      setModal('You have already reached the maximum number of bank account details allowed. To add new bank details, please contact Customer Service with a justification.');
      setIsModalWarning(true);
    }
    else {
      setModal('Do you want to update account?');
      setIsModalWarningYesNo(true);
    }



  }
  const onDelete = () => {
    setIsModalWarningYesNo(false);
    setLoader(true);
    deleteBankUpi({
      mobileNo: mobileNum,
      mappingId: userDetails[0].USER_BANK_MAPPING_ID,
      deleteType: 'bank',
    }, newData.token)
      .then((data) => {
        if (data.status.status === "Y" && data.statusMsg.code === 0) {
          setVerifyErrorMsg('');
          setUserDetails([]);
          setModal(data.statusMsg.msg);
          setIsModalSuccess(true);
          setAccountNumber('');
          setReAccountNumber('');
          setIfsc('');
          setBenName('');
          getUserInfo();
          setBankName('');
          setBranchName('');
          setLoader(false);
        }
        else if (data.status.status === "N" && data.statusMsg.code === 1) {
          setModal(data.statusMsg.msg);
          setIsModalWarning(true);
          setLoader(false);

        }
        else if (data.status.status === "N" && data.statusMsg.code === -1) {
          setModal(data.statusMsg.msg);
          setIsModalError(true);
          setLoader(false);

        }
      })
      .catch((error) => {
        setLoader(false);
      });

  };
  const handleChangeAccount = (event) => {
    setAccountNumber(event.target.value.replace(/\D/g, ''));
    let pattern = regex.accountRegex;
    let resAccount = pattern.test(event.target.value.replace(/\D/g, ''));
    setResultAccount(resAccount);
    if (!resAccount) {
      setAccountError("Please enter a valid account number")
    }
    if (reAccountNumber !== event.target.value.replace(/\D/g, '')) {
      setResultAccounts(false);
      setAccountErrors("Account number does not match");
    }
    else {
      setResultAccounts(true);
    }
  }
  const handleChangeAccounts = (event) => {
    setReAccountNumber(event.target.value.replace(/\D/g, ''));

    if (accountNumber !== event.target.value.replace(/\D/g, '')) {
      setResultAccounts(false);
      setAccountErrors("Account number does not match");
    }
    else {
      setResultAccounts(true);
    }
  }
  const handleChangeIfsc = (event) => {
    setIfsc(event.target.value.replace(/[^a-zA-Z0-9]/g, ''));
    let pattern = regex.ifscRegex;
    let resIfsc = pattern.test(event.target.value.replace(/[^a-zA-Z0-9]/g, ''));
    setResultIfsc(resIfsc);
    if (!resIfsc) {
      setIfscError("Please enter a valid IFSC code");
      setBankName('');
      setBranchName('');
    }
    else {
      setLoader(true);
      getIfscDetails(event.target.value.replace(/[^a-zA-Z0-9]/g, ''))
        .then((data) => {
          setBankName(data.BANK);
          setBranchName(data.BRANCH);
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
          setResultIfsc(false);
          if (!resIfsc) {
            setIfscError("Please enter a valid IFSC code");
            setBankName('');
            setBranchName('');
          }
        });

    }

  }
  const handleChangeBenName = (event) => {
    setBenName(event.target.value.replace(/[^a-zA-Z\s]/g, '').trimStart());
    let pattern = regex.nameRegex;
    let resName = pattern.test(event.target.value.replace(/[^a-zA-Z\s]/g, '').trimStart());
    setResultName(resName);

    if (!resName) {
      setBenNameError("Please enter a valid Name")
    }
  }
  return (
    <>
      <AppTracking pageName={window.location.pathname.replace(/\//g, '')} />
      <div className='content-wrapper responsive-wrapper'>
        <div className='row'>
          <div className='col-lg-4 col-md-4 col-sm-12 m-auto'>
            <div className='DarkPanel'>
              <div className='col-lg-12 col-md-12 col-sm-12'>
                <Bankdetails />
              </div>
            </div>
            <section className='FormPanel pt-4'>
              <div className=''>
                <div className=''>
                  <div>
                    {userDetails && userDetails?.length > 0 && (
                      <div className='FormPanel mb-4'>
                        <h3>Saved Bank Accounts</h3>
                        <h5 className='error text-danger text-start px-0'>{verifyErrorMsg}</h5>
                        {userDetails.map((user, index) => (
                          <div className='card p-3 mb-1' key={index}>
                            <div className='row d-flex justify-content-center align-items-center'>
                              <div className='col-8'>
                                {/* <p className='mb-0'>HDFC Bank - John Doe</p> */}
                                <p className='mb-0'>
                                  {user.BANK_NAME} -{' '}
                                  {user.BENEFICIARY_NAME}
                                </p>

                                <small>
                                  {maskBankAccountNumber(accountNumber)}
                                </small>

                                {/* <small>
                                  {maskBankAccountNumber(decode(user.BANK_ACCOUNT_NO))}
                                </small> */}
                              </div>
                              <div className='col-4'>
                                <div className='text-end'>
                                  <button
                                    type=''
                                    className='btn warning-btn'
                                    onClick={deleteAccount}
                                  >
                                    {/* <Delete /> */}
                                    Update A/C
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div className='row mt-4'>
                          <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='info-panel'>
                              <p>
                                {userInfo}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <h3>Bank Details</h3>

                  <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                      <label className='form-label'>
                        Bank Account Number
                      </label>
                      <input
                        type='text'
                        id='bankAccNo'
                        name='bankAccNo'
                        className='form-control'
                        maxLength={18}
                        minLength={6}
                        onPaste={handlePaste}
                        placeholder='Enter Bank Account Number'
                        value={accountNumber.toUpperCase()}
                        disabled={userDetails.length > 0}
                        inputMode='numeric'
                        onChange={(event) => handleChangeAccount(event)}
                      />
                      {!resultAccount && accountNumber !== '' ? (
                        <div className='error text-danger text-start'>
                          {accountError}
                        </div>
                      ) : null}
                    </div>
                    <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                      <label className='form-label'>
                        Re-enter Bank Account Number
                      </label>
                      <input
                        type='text'
                        id='reEnterbankAccNo'
                        name='reEnterbankAccNo'
                        className='form-control'
                        maxLength={18}
                        minLength={6}
                        onPaste={handlePaste}
                        placeholder='Re-enter Bank Account Number'
                        value={reAccountNumber.toUpperCase()}
                        disabled={userDetails.length > 0}
                        inputMode='numeric'
                        onChange={(event) => handleChangeAccounts(event)}
                      />
                      {!resultAccounts && reAccountNumber !== '' ? (
                        <div className='error text-danger text-start'>
                          {accountErrors}
                        </div>
                      ) : null}
                    </div>
                    <div className='col-lg-12 col-md-12 col-sm-12 mb-1'>
                      <label className='form-label'>
                        IFSC Code
                      </label>
                      <input
                        id='ifsc'
                        name='ifsc'
                        type='text'
                        className='form-control'
                        placeholder='Enter IFSC Code'
                        maxLength={11}
                        value={ifsc.toUpperCase()}
                        disabled={userDetails.length > 0}
                        onChange={(event) => handleChangeIfsc(event)}

                      />
                      {!resultIfsc ? (
                        <div className='error text-danger text-start'>
                          {ifscError}
                        </div>
                      ) : null}
                    </div>
                    {bankName !== '' ?
                      <div className='col-lg-12 col-md-12 col-sm-12'>
                        <div className='ifse-name'>{bankName}, {branchName}</div>
                      </div>
                      : ''}

                    <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                      <label className='form-label'>
                        Beneficiary Name
                      </label>
                      <input
                        id='name'
                        name='name'
                        type='text'
                        className='form-control'
                        placeholder='Enter Beneficiary Name'
                        value={benName.toUpperCase()}
                        maxLength={50}
                        disabled={userDetails.length > 0}
                        onChange={(event) => handleChangeBenName(event)}
                      />
                      {!resultName ? (
                        <div className='error text-danger text-start'>
                          {benNameError}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-12 col-md-12 col-sm-12 mb-2 mt-2'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={handleSubmit}
                    disabled={!resultAccount || !resultAccounts || !resultIfsc || !resultName || benName === ''}
                  >
                    Transfer
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Modal className="success" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalSuccess} onHide={() => handleClose(1)} >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/accept.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(1)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="error" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalError} onHide={() => handleClose(2)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/cross.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(2)}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal >
      <Modal className="alert" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalWarning} onHide={() => handleClose(3)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/caution.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(3)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="alert" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalWarningYesNo} onHide={() => handleClose(4)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/caution.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="text-center">
              <Button variant="secondary" className="" onClick={() => onDelete()}>
                Yes
              </Button>
            </div>

          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="text-center">
              <Button variant="secondary" className="btn-cancel" onClick={() => handleClose(4)}>
                No
              </Button>
            </div>

          </div>
          {/* <Button variant="secondary" className="" onClick={() => handleClose(3)}>
            OK
          </Button> */}
        </Modal.Footer>
      </Modal>
      {loader && (
        <div id="overlay">
          <span className="loader"></span>
        </div>
      )}
      {loaderTrans && (
        <div className="loader1">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default BankDetailsPage;
